module.exports = __webpack_public_path__ + "img/gerencia.6c6c395d.svg";